import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';

@Component({
	selector: 'rx-lab-broker-footer',
	templateUrl: './lab-broker-footer.component.html',
	styleUrls: ['./lab-broker-footer.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, TlkButtonComponent]
})
export class LabBrokerFooterComponent {
	@Input() integratorName: string | null = null;

	@Input() isSaveAndContinueLaterVisible = false;

	@Input() isSendToLabVisible = false;

	@Output() sendClicked = new EventEmitter<void>();
	@Output() saveAndContinueLaterClicked = new EventEmitter<void>();

	onSendClicked(): void {
		this.sendClicked.emit();
	}

	onSaveAndContinueLaterClicked(): void {
		this.saveAndContinueLaterClicked.emit();
	}
}
